import React from 'react';
import { motion } from 'framer-motion';
import { Zap, FlaskConical, Atom, Zap as Electron, Beaker, Leaf, Trophy } from 'lucide-react';
const volumes = [{
  year: '1°',
  color: 'bg-blue-500'
}, {
  year: '2°',
  color: 'bg-green-500'
}, {
  year: '3°',
  color: 'bg-orange-500'
}, {
  year: '4°',
  color: 'bg-purple-500'
}, {
  year: '5°',
  color: 'bg-slate-500'
}];
const details = [{
  title: 'CUADERNILLO 1 — FUNDAMENTOS DE QUÍMICA Y SISTEMAS MATERIALES',
  desc: 'Materia, propiedades, estados de agregación, modelo de partículas y transformaciones físicas y químicas.',
  icon: <FlaskConical className="text-blue-600" data-id="element-185" />
}, {
  title: 'CUADERNILLO 2 — ESTRUCTURA ATÓMICA Y TABLA PERIÓDICA',
  desc: 'Modelos atómicos, partículas subatómicas, número atómico, número másico, isótopos, iones, tabla periódica y propiedades periódicas.',
  icon: <Atom className="text-green-600" data-id="element-186" />
}, {
  title: 'CUADERNILLO 3 — CONFIGURACIÓN ELECTRÓNICA Y ENLACES QUÍMICOS',
  desc: 'Distribución electrónica, bloques de la tabla periódica, enlaces iónicos, covalentes y metálicos, y estructuras de Lewis.',
  icon: <Electron className="text-orange-600" data-id="element-187" />
}, {
  title: 'CUADERNILLO 4 — QUÍMICA INORGÁNICA Y REACCIONES',
  desc: 'Números de oxidación, formulación, nomenclatura, compuestos inorgánicos, reacciones químicas, balanceo y estequiometría.',
  icon: <Beaker className="text-purple-600" data-id="element-188" />
}, {
  title: 'CUADERNILLO 5 — QUÍMICA ORGÁNICA, SALUD Y AMBIENTE',
  desc: 'Carbono, hidrocarburos, grupos funcionales, polímeros, bioquímica básica, salud y química ambiental.',
  icon: <Leaf className="text-slate-600" data-id="element-189" />
}];
export function ProductBreakdown() {
  return <section className="py-6 md:py-12 px-4 max-w-4xl mx-auto" data-id="element-190">
      <div className="text-center mb-6 md:mb-10" data-id="element-191">
        <div className="inline-flex items-center gap-2 text-blue-600 font-black tracking-widest text-sm uppercase mb-4" data-id="element-192">
          <Zap size={18} className="fill-blue-600" data-id="element-193" />
          <span data-id="element-194">Química Visual</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 leading-tight" data-id="element-195">
          MEGAPACK QUÍMICA VISUAL™ EDICIÓN LATAM
        </h2>
        <p className="text-slate-600 font-bold text-sm md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-196">
          5 cuadernillos organizados por niveles. +600 páginas con teoría clara,
          actividades secuenciadas, rúbricas, experiencias de laboratorio y
          proyectos integradores.
        </p>
      </div>

      <div className="grid grid-cols-5 gap-2 md:gap-4 mb-8 md:mb-12" data-id="element-197">
        {volumes.map((v, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className={`${v.color} aspect-[3/4] rounded-lg md:rounded-xl flex flex-col items-center justify-center text-white shadow-lg relative overflow-hidden group`} data-id="element-198">
            <span className={`font-black ${v.isSpecial ? 'text-[10px] md:text-xs' : 'text-xl md:text-2xl'}`} data-id="element-199">
              {v.year}
            </span>
            {v.isSpecial && <Trophy size={14} className="mt-1" data-id="element-200" />}
          </motion.div>)}
      </div>

      <div className="space-y-4" data-id="element-201">
        {details.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-202">
            <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-203">
              {item.icon}
            </div>
            <div data-id="element-204">
              <h4 className="font-black text-slate-900 text-sm md:text-lg mb-1 leading-tight" data-id="element-205">
                {item.title}
              </h4>
              <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium" data-id="element-206">
                {item.desc}
              </p>
            </div>
          </motion.div>)}

        {/* Block A */}
        <motion.div initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-207">
          <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-208">
            <Zap className="text-blue-600" data-id="element-209" />
          </div>
          <div data-id="element-210">
            <h4 className="font-black text-slate-900 text-sm md:text-lg mb-2 leading-tight" data-id="element-211">
              NUEVO: BIBLIOTECA QUÍMICA VISUAL™
            </h4>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium mb-3" data-id="element-212">
              Más de 150 fichas ilustradas con explicaciones breves, esquemas,
              ejemplos y recursos visuales para facilitar la comprensión de los
              contenidos más importantes de química.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-slate-600 text-xs md:text-sm font-medium mb-3" data-id="element-213">
              <li className="flex items-center gap-1.5" data-id="element-214">
                <span className="text-blue-600" data-id="element-215">✓</span> Materia y sistemas
                materiales
              </li>
              <li className="flex items-center gap-1.5" data-id="element-216">
                <span className="text-blue-600" data-id="element-217">✓</span> Estructura atómica
              </li>
              <li className="flex items-center gap-1.5" data-id="element-218">
                <span className="text-blue-600" data-id="element-219">✓</span> Tabla periódica
              </li>
              <li className="flex items-center gap-1.5" data-id="element-220">
                <span className="text-blue-600" data-id="element-221">✓</span> Enlaces químicos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-222">
                <span className="text-blue-600" data-id="element-223">✓</span> Números de oxidación
              </li>
              <li className="flex items-center gap-1.5" data-id="element-224">
                <span className="text-blue-600" data-id="element-225">✓</span> Compuestos inorgánicos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-226">
                <span className="text-blue-600" data-id="element-227">✓</span> Reacciones químicas y
                balanceo
              </li>
              <li className="flex items-center gap-1.5" data-id="element-228">
                <span className="text-blue-600" data-id="element-229">✓</span> Estequiometría
              </li>
              <li className="flex items-center gap-1.5" data-id="element-230">
                <span className="text-blue-600" data-id="element-231">✓</span> Soluciones
              </li>
              <li className="flex items-center gap-1.5" data-id="element-232">
                <span className="text-blue-600" data-id="element-233">✓</span> Ácidos, bases y pH
              </li>
              <li className="flex items-center gap-1.5" data-id="element-234">
                <span className="text-blue-600" data-id="element-235">✓</span> Química orgánica
              </li>
            </ul>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium" data-id="element-236">
              El material se entrega en documentos completos y también en fichas
              individuales para que cada docente pueda imprimir o compartir
              únicamente lo que necesita.
            </p>
          </div>
        </motion.div>

        {/* Block B */}
        <motion.div initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="bg-white p-5 md:p-6 rounded-2xl border border-blue-50 shadow-sm flex gap-4 items-start" data-id="element-237">
          <div className="bg-slate-50 p-3 rounded-xl shrink-0" data-id="element-238">
            <Trophy className="text-blue-600" data-id="element-239" />
          </div>
          <div data-id="element-240">
            <h4 className="font-black text-slate-900 text-sm md:text-lg mb-2 leading-tight" data-id="element-241">
              MÁS DE 200 ACTIVIDADES LISTAS PARA UTILIZAR
            </h4>
            <p className="text-slate-600 text-xs md:text-base leading-relaxed font-medium mb-3" data-id="element-242">
              Incluye ejercicios de completamiento, clasificación, formulación,
              nomenclatura, interpretación, resolución de cálculos, desafíos
              integradores y actividades de reflexión. Muchas actividades
              incluyen formatos A y B para trabajar el mismo contenido mediante
              consignas diferentes.
            </p>
            <p className="text-slate-600 text-xs md:text-sm font-bold mb-2" data-id="element-243">
              Esto permite:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-slate-600 text-xs md:text-sm font-medium" data-id="element-244">
              <li className="flex items-center gap-1.5" data-id="element-245">
                <span className="text-blue-600" data-id="element-246">✓</span> Trabajar con diferentes
                grupos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-247">
                <span className="text-blue-600" data-id="element-248">✓</span> Reducir la copia de
                respuestas
              </li>
              <li className="flex items-center gap-1.5" data-id="element-249">
                <span className="text-blue-600" data-id="element-250">✓</span> Utilizar una versión
                para práctica y otra para evaluación
              </li>
              <li className="flex items-center gap-1.5" data-id="element-251">
                <span className="text-blue-600" data-id="element-252">✓</span> Observar diferentes
                procedimientos
              </li>
              <li className="flex items-center gap-1.5" data-id="element-253">
                <span className="text-blue-600" data-id="element-254">✓</span> Realizar recuperaciones
              </li>
              <li className="flex items-center gap-1.5" data-id="element-255">
                <span className="text-blue-600" data-id="element-256">✓</span> Adaptar las actividades
                según cada estudiante
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}